<template>
  <SoWidget title="Site Visit History" :loading="isLoading">
    <SoSelect
      v-model="selectedFilters"
      :items="filterOptions"
      type="multiple"
      placeholder="Filter"
      class="mb-2"
    />
    <MeterAppointmentSlot
      :is-loading="isLoading"
      :feed-item-list="filteredAppointments"
      :pagination-reset-key="selectedFilters.join(',')"
    />
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoWidget from "@/components/SoWidget.vue"
  import MeterAppointmentSlot from "../../timeline/activityFeed/MeterAppointmentSlot.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import { MeterAppointmentStatus } from "@/models/meterAppointment/meterAppointment.types"
  import { MeterAppointment } from "@/models/meterAppointment/meterAppointment"
  import { IItemsByDate } from "@/models/activityFeed/ActivityFeedItem"

  interface IAppointmentFilterOptions {
    title: string
    value: MeterAppointmentStatus
  }

  export default defineComponent({
    components: {
      SoWidget,
      MeterAppointmentSlot,
      SoSelect,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        selectedFilters: [] as Array<string>,
        filterOptions: [
          {
            title: "Booked",
            value: MeterAppointmentStatus.BOOKED,
          },
          {
            title: "Cancelled",
            value: MeterAppointmentStatus.CANCELLED,
          },
          {
            title: "Aborted",
            value: MeterAppointmentStatus.ABORTED,
          },
          {
            title: "Completed",
            value: MeterAppointmentStatus.COMPLETED,
          },
          {
            title: "Rescheduled",
            value: MeterAppointmentStatus.RESCHEDULED,
          },
        ] as IAppointmentFilterOptions[],
      }
    },
    computed: {
      isLoading() {
        return this.current.meterAppointmentEvents.isFetching
      },
      filteredAppointments(): IItemsByDate[] {
        if (!this.selectedFilters.length)
          return this.current.meterAppointmentEvents.data

        const filteredItems: IItemsByDate[] = []

        this.current.meterAppointmentEvents.data.forEach((event) =>
          filteredItems.push({
            date: event.date,
            items: event.items.filter((ticket) =>
              this.selectedFilters.includes(
                MeterAppointmentStatus[
                  (ticket.item as MeterAppointment).aesStatus as string
                ],
              ),
            ),
          }),
        )

        return filteredItems.filter((item) => item.items.length > 0)
      },
    },
  })
</script>
